// extracted by mini-css-extract-plugin
export var infoSection = "_u-1";
export var infoSectionContainer = "_u-0";
export var infoSectionTitleRow = "_u-2";
export var multiLineInfo = "_u-4";
export var strong = "_u-3";